
import {initWebComponent} from "@/helpers/web-component-helper";
import {getAllBySelector, getBySelector, removeClassBySelector} from "@/helpers/element-helper";

export class LayerInfoButtonComponent extends HTMLElement {
    constructor(){
        super();

        const title = this.getAttribute('data-title')
        let icon = this.getAttribute('data-icon')

        const template = document.createElement('template');

        let extraClass = ''
        if(icon === 'fa fa-info') {
            icon += ' ml-1'
        }
        if(icon === 'fa fa-filter') {
            extraClass = ' btn-filter'
        }
        if(icon === 'fa fa-edit') {
            extraClass = ' btn-mutation'
        }
        if(icon === 'fa fa-tag') {
            extraClass = ' btn-characteristics'
        }

        template.innerHTML = `<div class="info-menu-btn-div  ${extraClass}">
            <div class="info-menu-btn popper-header ">
              <span class="` + icon + ` mr-2"></span>
               <div class="popper-tooltip" role="tooltip" data-popper-placement="left">
                     <layout-language data-key="` + title + `"></layout-language>
                <div class="arrow" data-popper-arrow=""></div>
              </div>
            </div>
          </div>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            const selector = this.querySelector('.info-menu-btn')
            if(selector.classList.contains('active')) {
                // removeClassBySelector('.info-menu-btn', 'active')
            } else {
                // removeClassBySelector('.info-menu-btn', 'active')
                selector.classList.add('active')
            }
        })
    }
}

